import type Principal from '../app/model/authentication/Principal';
import type CompanyHotel from '../app/model/company_hotel/CompanyHotel';
import ACLAuthority from '../app/model/profile/ACLAuthority';

export const hasPricingAuthority = (principal: Principal | undefined, required: ACLAuthority): boolean => {
    if (!principal?.isEnabled) return false;
    const authority = principal.pricingAuthority;
    return authority === ACLAuthority.WRITE
        || (authority === ACLAuthority.READ && required !== ACLAuthority.WRITE)
        || (authority === ACLAuthority.NONE && required === ACLAuthority.NONE);
};

export const getPricingRights = (principal: Principal | undefined, companyHotel: CompanyHotel | undefined) => ({
    canViewRecommendations: !!companyHotel?.hasPriceRecommendationModule() && hasPricingAuthority(principal, ACLAuthority.READ),
    canChangePrices: !!companyHotel?.hasPricingAutomationModule() && hasPricingAuthority(principal, ACLAuthority.WRITE),
});

export const pricingDayAction = (canViewRecommendations: boolean, canChangePrices: boolean, hasRecommendation: boolean) =>
    canChangePrices ? 'change' : canViewRecommendations && hasRecommendation ? 'view' : undefined;
